export const ExpandIcon = ({ isActive }) => {
  return (
    <>
      {isActive ? (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle
            cx="16"
            cy="16"
            r="15.75"
            transform="rotate(180 16 16)"
            fill="white"
            stroke="#B3ABAB"
            strokeWidth="0.5"
          />
          <path
            d="M22.4006 19.2L16.0006 12.8L9.60059 19.2"
            stroke="#969494"
            strokeWidth="1.03448"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="15.75" fill="white" stroke="#B3ABAB" strokeWidth="0.5" />
          <path
            d="M9.59941 12.7999L15.9994 19.1999L22.3994 12.7999"
            stroke="#969494"
            strokeWidth="1.03448"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </>
  );
};

export const BackArrow = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
      <g>
        <rect y="0.5" width="24" height="24" fill="#fff" />
        <path
          d="M18.7905 11.5051H7.62051L12.5005 6.62508C12.8905 6.23508 12.8905 5.59508 12.5005 5.20508C12.3137 5.01783 12.06 4.9126 11.7955 4.9126C11.531 4.9126 11.2773 5.01783 11.0905 5.20508L4.50051 11.7951C4.11051 12.1851 4.11051 12.8151 4.50051 13.2051L11.0905 19.7951C11.4805 20.1851 12.1105 20.1851 12.5005 19.7951C12.8905 19.4051 12.8905 18.7751 12.5005 18.3851L7.62051 13.5051H18.7905C19.3405 13.5051 19.7905 13.0551 19.7905 12.5051C19.7905 11.9551 19.3405 11.5051 18.7905 11.5051Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
export const LogoMain = () => {
  return (
    <svg width="341" height="124" viewBox="0 0 341 124" fill="none">
      <path d="M341 124V0H170.5H0V124H341Z" fill="#7438F2" />
      <path
        d="M170.812 36.698H234.037V51.637H188.498V59.937H234.037V74.791H183.867L188.498 78.025V88.348V97.303H170.812V36.698Z"
        fill="white"
      />
      <path
        d="M107.686 59.531H148.526V36.698H166.212V97.303H148.526V74.47H103.054L107.686 77.795V97.303H90V36.698H107.686V59.531Z"
        fill="white"
      />
      <path
        d="M256.157 77.44C256.157 80.156 257.752 82.25 260.942 83.721C264.189 85.136 269.628 85.844 277.261 85.844C284.21 85.844 288.995 85.334 291.615 84.316C294.235 83.297 295.545 81.769 295.545 79.732C295.545 78.204 295.061 77.073 294.093 76.337C293.124 75.601 291.245 75.035 288.454 74.639C285.663 74.187 281.077 73.762 274.698 73.366C266.211 72.8 259.376 71.81 254.192 70.395C249.066 68.924 245.25 66.83 242.743 64.114C240.294 61.398 239.07 57.805 239.07 53.334C239.07 47.223 242.145 42.639 248.297 39.584C254.449 36.528 262.993 35 273.929 35C285.776 35 294.919 36.754 301.355 40.263C307.848 43.771 311.209 48.864 311.437 55.541H292.982C292.982 52.882 291.444 50.986 288.368 49.854C285.292 48.722 280.308 48.156 273.416 48.156C267.322 48.156 263.135 48.609 260.857 49.515C258.635 50.42 257.524 51.778 257.524 53.589C257.524 54.89 258.009 55.909 258.977 56.645C259.945 57.38 261.768 58.003 264.445 58.512C267.179 58.965 271.366 59.417 277.005 59.87C286.118 60.549 293.096 61.37 297.937 62.332C302.836 63.294 306.738 65.048 309.643 67.594C312.548 70.141 314 73.932 314 78.968C314 86.324 310.896 91.502 304.687 94.501C298.535 97.5 289.593 99 277.859 99C264.929 99 255.075 97.331 248.297 93.992C242.427 91.076 238.968 86.498 237.921 80.259C237.769 79.354 237.668 78.415 237.617 77.44H256.157Z"
        fill="white"
      />
    </svg>
  );
};
export const UploadIcon = () => {
  return (
    <svg height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor">
      <path d="M440-200h80v-167l64 64 56-57-160-160-160 160 57 56 63-63v167ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z" />
    </svg>
  );
};
